module.exports = __webpack_public_path__ + "img/dice5.f3ebe346.svg";